(function () {

  function initProductInfoPopups() {

    const containers = document.querySelectorAll(
      '.product-info-popup-block'
    );

    if (!containers.length) {
      return;
    }


    containers.forEach(function (container) {

      /*
       * Prevent duplicate initialization
       */

      if (
        container.dataset.popupInitialized === 'true'
      ) {
        return;
      }

      container.dataset.popupInitialized = 'true';


      /*
       * Find popup buttons
       */

      const openButtons =
        container.querySelectorAll(
          '[data-popup-open]'
        );


      /*
       * Find popup modals
       */

      const modals =
        container.querySelectorAll(
          '.product-info-popup-block__modal'
        );


      /*
       * =====================================================
       * IMPORTANT FIX
       *
       * Move popup directly to BODY.
       *
       * This makes the popup appear ABOVE
       * the Shopify header.
       * =====================================================
       */

      modals.forEach(function (modal) {

        document.body.appendChild(modal);

      });


      /*
       * =====================================================
       * OPEN POPUP
       * =====================================================
       */

      openButtons.forEach(function (button) {

        button.addEventListener(
          'click',
          function () {

            const popupName =
              button.getAttribute(
                'data-popup-open'
              );


            /*
             * Close other popups
             */

            modals.forEach(function (modal) {

              modal.classList.remove(
                'is-open'
              );

              modal.setAttribute(
                'aria-hidden',
                'true'
              );

            });


            /*
             * Find selected popup
             */

            let selectedModal = null;


            modals.forEach(function (modal) {

              const modalName =
                modal.getAttribute(
                  'data-popup'
                );


              if (
                modalName === popupName
              ) {

                selectedModal = modal;

              }

            });


            /*
             * Open selected popup
             */

            if (!selectedModal) {
              return;
            }


            selectedModal.classList.add(
              'is-open'
            );

            selectedModal.setAttribute(
              'aria-hidden',
              'false'
            );


            /*
             * Stop page scrolling
             */

            document.body.style.overflow =
              'hidden';


            /*
             * Focus close button
             */

            const closeButton =
              selectedModal.querySelector(
                '.product-info-popup-block__close'
              );


            if (closeButton) {

              setTimeout(
                function () {

                  closeButton.focus();

                },
                50
              );

            }

          }
        );

      });


      /*
       * =====================================================
       * CLOSE POPUP
       * =====================================================
       */

      modals.forEach(function (modal) {

        const closeButtons =
          modal.querySelectorAll(
            '[data-popup-close]'
          );


        closeButtons.forEach(
          function (button) {

            button.addEventListener(
              'click',
              function (event) {

                event.preventDefault();


                modal.classList.remove(
                  'is-open'
                );


                modal.setAttribute(
                  'aria-hidden',
                  'true'
                );


                /*
                 * Enable page scrolling
                 */

                document.body.style.overflow =
                  '';

              }
            );

          }
        );

      });



      document.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key !== 'Escape'
          ) {
            return;
          }


          let popupWasOpen = false;


          modals.forEach(
            function (modal) {

              if (
                modal.classList.contains(
                  'is-open'
                )
              ) {

                modal.classList.remove(
                  'is-open'
                );


                modal.setAttribute(
                  'aria-hidden',
                  'true'
                );


                popupWasOpen = true;

              }

            }
          );


          if (popupWasOpen) {

            document.body.style.overflow =
              '';

          }

        }
      );

    });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initProductInfoPopups
    );

  } else {

    initProductInfoPopups();

  }


})();